// @flow
import React from 'react';
import classnames from 'classnames';

import { t } from 'Src/i18n';
import { type FacetTemplateConfig } from 'Utils/faceting/constants';
import { FacetList } from './FacetList';

type Props = {
  activeFacets: *,
  facetsFromSearch: Array<SearchFacetCategory>,
  onChange: (name: string, checked: boolean, value: string | boolean) => void,
  templateConfig: FacetTemplateConfig,
};
export const FacetCategory = ({
  facetsFromSearch,
  onChange,
  templateConfig,
  activeFacets,
}: Props) => {
  const { id: facetId, facetLists: facetListsConfig = [] } = templateConfig;

  const localizeFacetLabel = (facet: SearchFacetList, facetLabelsFolder: string) => {
    if (!facetLabelsFolder) {
      return facet;
    }

    const localizedLabel = t(`${facetLabelsFolder}.label_${facet.value.toLowerCase()}`);

    if (!localizedLabel) {
      return facet;
    }

    return {
      ...facet,
      label: localizedLabel,
    };
  };

  return (
    <div className="my-4" key={facetId}>
      <div className={classnames('lg:flex', 'FacetCategory', `FacetCategory-${facetId}`)}>
        {facetListsConfig.map(({ deep, id: subFacetId, facetLabels, titleLabel }) => {
          const facetFromSearch = facetsFromSearch.find(({ id }) => id === subFacetId);

          if (!facetFromSearch || !facetFromSearch.list) {
            return;
          }

          if (!deep) {
            return (
              <FacetList
                activeFacets={activeFacets[subFacetId]}
                className={`FacetList-${subFacetId}`}
                facets={facetFromSearch.list.map(facet => localizeFacetLabel(facet, facetLabels))}
                key={subFacetId}
                name={subFacetId}
                onChange={onChange}
                title={t(titleLabel)}
              />
            );
          }

          return facetFromSearch.list.map(({ label, list = [], value }) => (
            <FacetList
              activeFacets={activeFacets[subFacetId]}
              className={classnames('lg:flex-1', `FacetList-${subFacetId}`)}
              facets={list.map(facet => localizeFacetLabel(facet, facetLabels)) || []}
              key={value}
              name={subFacetId}
              onChange={onChange}
              title={label || t(titleLabel)}
            />
          ));
        })}
      </div>
    </div>
  );
};
